document.addEventListener('DOMContentLoaded', () => {
    let mm = gsap.matchMedia()
    mm.add("(min-width: 1024px)", () => {
        const marqueeList = document.querySelectorAll('.section-about__img-track-box')
        if (!marqueeList.length) {
            return;
        }

        marqueeList.forEach((marquee, index) => {
            const marqueeContent = marquee.querySelector('.section-about__img-track');

            const marqueeContentClone = marqueeContent.cloneNode(true);
            marquee.append(marqueeContentClone);

            const height = parseInt(window.getComputedStyle(marqueeContent).getPropertyValue("height"), 10);
            gsap.utils.toArray(marquee.children).forEach(child => {
                gsap.to(
                    child,
                    {
                        y: `${index === 0 ? '+' : '-'}=${height}`,
                        duration: 25,
                        ease: "none",
                        repeat: -1
                    }
                )
            })
        })
    })
});